import React from "react";
import { PublicLayout, Eyebrow, SectionCTA, IMG } from "@/components/public/PublicKit";
import { Building2, HeartPulse, Pill, Syringe, CheckCircle2 } from "lucide-react";

const SOLUTIONS = [
  {
    icon: Building2, title: "Management Services Organizations (MSOs)", img: IMG.team,
    desc: "Coordinate provider acquisition and multi-service onboarding across every managed practice.",
    points: ["One view of practices, owners and opportunities", "Onboard clients into several services at once", "Track readiness and activation across the network", "See next actions and overdue follow-ups by owner"],
  },
  {
    icon: HeartPulse, title: "RPM providers", img: IMG.hero,
    desc: "Move practices from interested to enrolled and keep remote monitoring activations on track.",
    points: ["Attribute referrals to the practices that send them", "Track 'Started with a partner for RPM' milestones", "Assign the responsible owner and partner per client", "Follow-up dates so no activation stalls"],
  },
  {
    icon: Pill, title: "Specialty pharmacy & 340B organizations", img: IMG.pharmacy,
    desc: "Track prescription activation and 340B service milestones per client and partner.",
    points: ["Per-client 340B service status and owner", "'Started writing prescription' milestone tracking", "Referral workflow from submission to completion", "Clear separation of sales stage and service status"],
  },
  {
    icon: Syringe, title: "Infusion providers", img: IMG.infusion,
    desc: "Follow infusion referrals and know exactly when a client starts sending.",
    points: ["'Client is sending Infusion' milestone", "Receiving-partner and owner on every referral", "Internal reference numbers for operational tracking", "Activity recorded on the client's timeline"],
  },
];

export default function Solutions() {
  return (
    <PublicLayout>
      <section className="border-b border-slate-100 bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
          <Eyebrow>Solutions</Eyebrow>
          <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Built for the teams activating 340B, RPM and infusion services</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-500">HudlUp adapts to how your organization acquires providers and activates services.</p>
        </div>
      </section>

      {SOLUTIONS.map((s, i) => (
        <section key={s.title} className={i % 2 ? "bg-slate-50" : "bg-white"}>
          <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 py-14 lg:grid-cols-2 lg:px-8">
            <div className={i % 2 ? "lg:order-2" : ""}>
              <div className="mb-4 inline-flex rounded-xl bg-primary/10 p-3 text-primary"><s.icon className="h-6 w-6" /></div>
              <h2 className="font-display text-2xl font-bold text-slate-900 sm:text-3xl">{s.title}</h2>
              <p className="mt-2 text-lg text-slate-500">{s.desc}</p>
              <ul className="mt-5 space-y-2.5">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-slate-600"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-primary" /><span>{p}</span></li>
                ))}
              </ul>
            </div>
            <div className={i % 2 ? "lg:order-1" : ""}>
              <img src={s.img} alt={s.title} loading="lazy" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-lg ring-1 ring-slate-200" />
            </div>
          </div>
        </section>
      ))}

      <SectionCTA />
    </PublicLayout>
  );
}
